import type { IFlatgroundObjectData } from "./FlatgroundObject";
import { FlatGroundSavedData } from "earthbrain-viewer";
import { ObjectType } from "./types";

export interface IFlatgroundObjectProps_Outdated {
	id: string;
	cid: string;
	type: number;
	name: string;
	isShow: boolean;
	isOpen: boolean;
	edit: boolean;
	panel: {
		shelf: boolean;
		volume: boolean;
		cutFlat: boolean;
		flatGround: boolean;
	};
	cutVolume: number;
	fillVolume: number;
	surfaceArea: number;
	transparency: number;
	info: {
		maxHeight: string;
	};
	settings: {
		commonSettings: {
			interpolationPitch: number;
			withSlope: boolean;
			color?: string;
		};
		cutSettings: {
			height: number;
			moundSlope: number;
			shelfWidth: number;
			shelfSlope: number;
			generateShelf: boolean;
			color: string;
		};
		embankmentSettings: {
			height: number;
			moundSlope: number;
			shelfWidth: number;
			shelfSlope: number;
			generateShelf: true;
			color: string;
		};
	};
	json: string;
	isLoaded: boolean;
}

export interface IFlatgroundObjectData_Version1 extends IFlatgroundObjectData {
	version: 1.0;
}

type TFlatgroundSavedData =
	| IFlatgroundObjectData_Version1
	| IFlatgroundObjectProps_Outdated;

export class FlatgroundObjectAdapter {
	private static async fromProps_Outdated(
		data: IFlatgroundObjectProps_Outdated,
		json: string,
	): Promise<IFlatgroundObjectData> {
		const flatgroundData = await FlatGroundSavedData.parseFlatGroundSavedData(
			json,
			0,
		);
		return {
			id: data.cid,
			type: ObjectType.FLAT_GROUND,
			md5: "",
			name: data.name,
			panel: data.panel,
			cutVolume: data.cutVolume,
			fillVolume: data.fillVolume,
			surfaceArea: data.surfaceArea,
			transparency: data.transparency,
			maxHeight: Number(data.info.maxHeight),
			surfaceSettings: {
				...data.settings.commonSettings,
				color: data.settings.commonSettings.color ?? "#DDDDDD",
			},
			cutSettings: data.settings.cutSettings,
			fillSettings: data.settings.embankmentSettings,
			associatedTerrain: {
				id: flatgroundData.associatedTerrain.id,
				terrainType: flatgroundData.associatedTerrain.terrainType,
			},
			points: flatgroundData.points,
		};
	}

	private static fromFlatgroundData_Version1(
		data: IFlatgroundObjectData_Version1,
	): IFlatgroundObjectData {
		return data;
	}

	public static async toFlatgroundData(
		data: TFlatgroundSavedData,
		json: string,
	): Promise<IFlatgroundObjectData> {
		if ("version" in data && data.version === 1.0) {
			return this.fromFlatgroundData_Version1(
				data as IFlatgroundObjectData_Version1,
			);
		} else {
			if (!json) {
				throw new Error(
					"json parameter is required for outdated flat ground data format",
				);
			}
			return this.fromProps_Outdated(
				data as IFlatgroundObjectProps_Outdated,
				json,
			);
		}
	}
}
